import React from 'react'
import styled from 'styled-components'

import { H2 } from '~/components/common/headers'
import { ColumnFlexCentered } from '~/components/common/containers'
import { translate } from '~/core/translate'

const Container = styled(ColumnFlexCentered)`
  max-width: 400px;
  text-align: center;
  margin-bottom: 16px;
`

const StyledH2 = styled(H2)`
  text-align: center;
  margin-top: 16px;
  margin-bottom: 32px;
  font-weight: normal;
`

export default () =>
  <Container>
    <StyledH2>
      {translate('limited_offer')}
    </StyledH2>
    <b>{translate('upgrade_legacy_notice')}</b>
  </Container>
